import styled from "styled-components";


export const H1 = styled.h1`

  font-family: AvenirLTProHeavy, sans-serif;
  font-size:25px;
  font-weight: 500;
  line-height: 1.6;
  color: var(--c7);
  text-align: center;
`;

export const H5 = styled.h5`

  font-family: AvenirLTProBlack, sans-serif;
  font-size: 14px;
  font-weight: 200;
  line-height: 1.6;
  color: var(--menu-text);
  text-align: center;
`;

export const BoldUl = styled.ul`

  font-family: AvenirLTProHeavy, sans-serif;
  font-weight: bold;
`;

export const TableHeaderStyle = styled.p`

  font-family: AvenirLTProHeavy, sans-serif;
  font-size: 16px;
  font-weight: 200;
  line-height: 0;
  color: var(--menu-text);
`;

export const TableBodyStyle = styled.p`

  font-family: AvenirLTProLight, sans-serif;
  font-size: 14px;
  font-weight: 200;
  color: var(--menu-text);
  line-height: 1;
`;

export const Small = styled.small`

  font-family: AvenirLTProLight, sans-serif;
  font-size:12px;
  font-weight: 50;
  line-height: 0.5;
  color: var(--menu-text);
  text-align: center;
    
`;
export const NarrowFormPage = styled.div`
    margin-top:10px;
    display:flex;
    flex-wrap: wrap;
    justify-content:center;
    align-items:center;
    height:90dvh;
    min-height:650px;
    min-width: 90%;
`;

export const NarrowFormCardContainer = styled.div`
    width:500px;
    min-width:320px;
    display:flex;
    height:700px;
    max-height:100%;
    flex-direction:column;
    align-items:center;
    padding-left:10px;
    padding-right:10px;
`;

export const FormHeader = styled.div`

    display:flex;
    justify-content:center;

`;

export const FormSubHeader = styled.div`

    display:flex;
    justify-content:center;
    align-items:center;

`;

export const FormButtonContainer = styled.div`

    height: 10%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;

`;

export const FormButton = styled.button`
    
    font-family: AvenirLTProMedium, sans-serif;
    color:  white;
    width: 19.6em;
    border: 1.5px solid  var(--c5);
    background-color: var(--c1);
    border-radius: 5px;
    padding: 10px 10px;
    font-size: 1.1em;
    overflow: hidden;
    text-decoration: unset;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    margin-left: 10px;
    
    :hover {
        background-color:  var(--c3);
        text-decoration: none;
    }
`;

export const NarrowButton = styled.button`
    color:  white;
    width: 9em;
    border: 1.5px solid  var(--c5);
    background-color: var(--c1);
    border-radius: 5px;
    padding: 10px 10px;
    font-size: 1em;
    overflow: hidden;
    text-decoration: unset;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    margin-left: 10px;
    
    :hover {
        background-color:  var(--c3);
        text-decoration: none;
    }
`;

export const ClickableName = styled.div`
  color: var(--c1);
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

export const TableWrapper = styled.div`

    display: flex;
    flex-direction:column;
    width: 50%;
    padding: 2px;
    margin: 2px;
`;